import React, { Component } from 'react';
import i18n from 'i18n-react';
import PropTypes from 'prop-types';
import { sharing, storageKeys } from 'settings';
import { APIHandler, DataHandler, StorageHandler } from 'C4';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const target = document.querySelector('body');

const names = {
  facebook: 'fb',
  twitter: 'twitter',
  mail: 'email',
  download: 'download',
};

const callback = (mutationsList, observer) => {
  mutationsList.forEach(({ type, addedNodes }) => {
    if (type === 'childList' && addedNodes.length > 0) {
      const [node] = Array.from(addedNodes);
      if (node.nodeType === 1) {
        const shareElement = node.querySelector('.fancybox-share.fancybox-content');
        if (shareElement) {
          const buttons = shareElement.querySelectorAll('p a');
          StorageHandler.load('user')
            .then(({ response }) => {
              DataHandler.matchAppId()
                .then((appId) => {
                  Array.from(buttons).forEach((button, i) => {
                    const name = names[button.querySelector('span').innerHTML.toLowerCase()];
                    buttons[i].onclick = () => {
                      APIHandler.trackEvent(appId, response.email, name === 'download' ? 'downloads' : 'shares', name, button.href);
                    };
                  });
                });
            });
          observer.disconnect();
        }
      }
    }
  });
};

const observer = new MutationObserver(callback);
observer.observe(target, { childList: true });

export default class SharingPopup extends Component {
  constructor(props) {
    super(props);

    this.shareAnalyticsAPI = this.shareAnalyticsAPI.bind(this);
  }

  // eslint-disable-next-line class-methods-use-this
  shareAnalyticsAPI(name, value) {
    DataHandler.matchAppId().then((appId) => {
      StorageHandler.load(storageKeys.user).then((userObj) => {
        let email = '';
        ({ email } = userObj.response);
        APIHandler.trackEvent(appId, email, 'shares', name, value);
      });
    });
  }

  render() {
    const { url, triggerId } = this.props;
    let urlEncoded = url.replace(/ /g, '%20');
    urlEncoded = encodeURIComponent(url);

    // Image // Infographic (pdf or png) // Video
    const extension = url.substring(url.lastIndexOf('.') + 1);
    let shareSubject = sharing.imageEmailSubject;
    let shareCopy = sharing.imageEmailCopy;

    if (extension === 'pdf' || extension === 'png') {
      shareSubject = sharing.infographicEmailSubject;
      shareCopy = sharing.infographicEmailCopy;
    } else if (extension === 'mp4') {
      shareSubject = sharing.videoEmailSubject;
      shareCopy = sharing.videoEmailCopy;
    }

    const hide = { display: (triggerId ? 'none' : 'inline-block') };
    return (
      <div className="fancybox-share" id={(triggerId || null)} style={hide}>
        <h3>{i18n.translate('share.header')}</h3>
        <p>
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${urlEncoded}`}
            onClick={() => { this.shareAnalyticsAPI('facebook', urlEncoded); }}
            className="fancybox-share__button fancybox-share__button--fb"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
              <path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" />
            </svg>
            <span>Facebook</span>
          </a>
          <a
            href={`https://twitter.com/share?url=${urlEncoded}&text=${sharing.twitter}`}
            onClick={() => { this.shareAnalyticsAPI('twitter', urlEncoded); }}
            className="fancybox-share__button fancybox-share__button--tw"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
              <path
                d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22
                37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32
                359-208 16-11 30-25 41-42z"
              />
            </svg>
            <span>Twitter</span>
          </a>
          <a
            href={`mailto:?subject=${shareSubject}&body=${shareCopy} ${urlEncoded}`}
            onClick={() => { this.shareAnalyticsAPI('email', urlEncoded); }}
            className="fancybox-share__button fancybox-share__button--pt"
          >
            <FontAwesomeIcon icon={['far', 'at']} />
            <span>Mail</span>
          </a>
          <a
            onClick={() => { this.shareAnalyticsAPI('download', urlEncoded); }}
            href={`https://stack.travpromobile.com/download.php?url=${urlEncoded}`}
            className="fancybox-download__button fancybox-download__button--pt"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={['far', 'download']} />
            <span>{i18n.translate('share.download')}</span>
          </a>
        </p>
        <p>
          <input readOnly onFocus="this.select();" className="fancybox-share__input" type="text" value={url} />
        </p>
      </div>
    );
  }
}

SharingPopup.propTypes = {
  url: PropTypes.string.isRequired,
};
